import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createI18n } from 'vue-i18n'
import * as Sentry from '@sentry/vue'
import App from './App.vue'
import router from './router'
import fr from './i18n/fr.json'
import en from './i18n/en.json'
import './styles/fonts.css'
import './styles/main.scss'
import './styles/workspace.css'
import './styles/dashboard-typography.css'

const i18n = createI18n({
  legacy: false,
  locale: 'fr',
  fallbackLocale: 'en',
  messages: { fr, en }
})

const app = createApp(App)

// Initialize Sentry (only if DSN is configured)
const sentryDsn = import.meta.env.VITE_SENTRY_DSN as string | undefined
if (sentryDsn) {
  Sentry.init({
    app,
    dsn: sentryDsn,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
    ],
    tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
    environment: import.meta.env.MODE,
  })
}

app.use(createPinia())
app.use(router)
app.use(i18n)

app.mount('#app')
